{
  "de": {
    "models": {
      "name": "Schiffe",
      "model": {
        "metrics": {
          "base": "Basis",
          "crew": "Besatzung",
          "info": "Info",
          "levels": "Ebenen",
          "speed": "Geschwindigkeit"
        },
        "focus": "Fokus",
        "classification": "Klassifizierung",
        "size": "Größe",
        "beam": "Breite",
        "cargo": "Fracht",
        "crew": "Besatzung",
        "speed": "Geschwindigkeit",
        "minCrew": "min. Besatzung",
        "maxCrew": "max. Besatzung",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "Max. Geschwindigkeit",
        "scm": "SCM",
        "max": "Max",
        "groundMaxSpeed": "Max. Geschwindigkeit",
        "groundReverseSpeed": "Rückwärtsgeschwindigkeit",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "Preis",
        "groundAcceleration": "Beschleunigung",
        "groundDeceleration": "Verzögerung",
        "scmSpeedAcceleration": "Null auf SCM",
        "scmSpeedDeceleration": "SCM auf Null",
        "compare": {
          "groundMaxSpeed": "Max. Bodengeschwindigkeit",
          "groundReverseSpeed": "Rückwärts-Bodengeschwindigkeit",
          "groundAcceleration": "Bodenbeschleunigung",
          "groundDeceleration": "Bodenverzögerung"
        },
        "quantumFuelTankSize": "Quantum-Treibstoff",
        "hydrogenFuelTankSize": "Treibstoff",
        "pledgePrice": "Pledge-Preis",
        "height": "Höhe",
        "length": "Länge",
        "mass": "Masse",
        "manufacturer": "Hersteller",
        "hardpoints": "Aufhängungspunkte",
        "weapons": "Waffen",
        "equipment": "Ausrüstung",
        "variants": "Varianten",
        "productionStatus": "Produktionsstatus",
        "propulsion": "Antrieb",
        "modular": "Modular",
        "soldAt": "Verkauft bei?",
        "rentalAt": "Gemietet bei?",
        "lastUpdatedAt": "Zuletzt aktualisiert am?",
        "loaners": "Leihschiffe",
        "paints": "Lackierungen",
        "modules": "Module",
        "modulePackages": "Modulpakete",
        "upgrades": "Upgrade-Kits",
        "brochure": "Broschüre",
        "onSale": "Im Angebot",
        "salesPage": "Verkaufsseite",
        "addons": "Module & Upgrade-Kits",
        "productionStatuses": {
          "notAvailable": "N/A",
          "ready": "Hangar-bereit",
          "announced": "Angekündigt"
        }
      }
    }
  }
}
